import {
  CAN_CREATE_PROJECT, CAN_EDIT_PROJECT, CAN_VIEW_AUDIT, DR_MENU_ROLES, PROD_VIEW_ROLES,
  ESTIMATE_VIEW, ESTIMATE_MANAGE, RAB_VIEW, HPP_VIEW, MONEY_ROLES, MATERIAL_USAGE_VIEW, RAP_VIEW,
} from "@/lib/constants";

// Route-level guards; mirror the sidebar matrix and backend authorization.
export const R = {
  projects: ["Owner", "Manager", "Marketing", "Finance", "Admin Project", "Kepala Produksi", "Foreman"],
  projectCreate: CAN_CREATE_PROJECT,
  projectEdit: CAN_EDIT_PROJECT,
  master: ["Owner", "Manager", "Marketing", "Admin Project"],
  employees: ["Owner", "Manager", "Admin Project"],
  finance: MONEY_ROLES,
  materialUsage: MATERIAL_USAGE_VIEW,
  spareparts: RAP_VIEW,
  production: PROD_VIEW_ROLES,
  dailyReports: DR_MENU_ROLES,
  estimates: ESTIMATE_VIEW,
  estimateManage: ESTIMATE_MANAGE,
  rab: RAB_VIEW,
  hpp: HPP_VIEW,
  users: ["Owner"],
  audit: CAN_VIEW_AUDIT,
};
